import { render, staticRenderFns } from "./TemporaryPasswordSent.vue?vue&type=template&id=8478f9d4&scoped=true&"
import script from "./TemporaryPasswordSent.vue?vue&type=script&lang=js&"
export * from "./TemporaryPasswordSent.vue?vue&type=script&lang=js&"
import style0 from "./TemporaryPasswordSent.vue?vue&type=style&index=0&id=8478f9d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8478f9d4",
  null
  
)

export default component.exports